import WasmController from "../../react-lib/frameworks/WasmController";

import { History } from "history";

// APIS
import FastAPIRequestView from "issara-sdk/apis/FastAPIRequestViewM";
// PRX
import V3TopServicesListView from "issara-sdk/apis/V3TopServicesListView_apps_PRX";
import V3MedServicesListView from "issara-sdk/apis/V3MedServicesListView_apps_PRX";
import V3MedServicesDetailView from "issara-sdk/apis/V3MedServicesDetailView_apps_PRX";
import V3SearchProgramSpecialtyListView from "issara-sdk/apis/V3SearchProgramSpecialtyListView_apps_PRX";
import V3MedProgramsDetailView from "issara-sdk/apis/V3MedProgramsDetailView_apps_PRX";
import V3MedProgramsListView from "issara-sdk/apis/V3MedProgramsListView_apps_PRX";
// USERS
import UserFamilyAPI from "issara-sdk/apis/UserFamilyAPI_users";

// Types
import * as Types from "./Types";

// Interface
import { State as MainState } from "../MobSmartAppointmentInterface";

// Const.
import { APIS, LIMIT_SEARCH, URLS } from "./Constants";

import CONFIG from "config/config";
import { Item } from "semantic-ui-react";
import CheckRequireDiagRuleView from "issara-sdk/apis/CheckRequireDiagRuleView_apps_PRX";

export type State = Partial<{
  topServiceList: Types.TopServiceListType[];
  centerGroupList: Types.CenterGroupType[];
  appointmentCenterList: Types.AppointmentCenterType[];
  availableDoctorSearch?: Types.AppDoctorResponse;
  allAvailableDoctorList: Types.AppDoctorResponse;
  doctorSearchList: Types.AppDoctorResponse | null;
  medServiceLists: Record<string, any>[];
  medServiceDetail: Record<string, any>;
  medProgramLists: Record<string, any>[];
}>;

type Picked = Partial<
  Pick<
    MainState,
    | "selectedHospital"
    | "loadingStatus"
    | "loadingSearch"
    | "textSearch"
    | "hospitalList"
    | "language"
  >
>;

export const StateInitial: State = {};

export type Event =
  // Handler
  | {
      message: "HandleDoctorAppointmentAction";
      params: {
        doctor: Types.AppointmentDoctorType;
        action?: Types.DoctorAppointmentActionType;
        history: History<any>;
        storedState?: Record<string, any>;
        card?: string;
        division?: Record<string, any>;
      };
    }
  // Get
  | {
      message: "GetListCenterGroup";
      params: { hospital?: string; card?: string; lang: string };
    }
  | {
      message: "GetListAppointmentCenter";
      params: { hospital?: string; lang: string, centerGroup?: number };
    }
  | {
      message: "GetListAvailableDoctor";
      params: {
        card: string;
        page: number;
        concat?: boolean;
        refresh?: boolean;
        status?: boolean;
        history?: any;
      } & Types.FilterDoctorType;
    }
  | { message: "GetListMedService"; params: { hospital: string; card: string } }
  | {
      message: "GetMedServiceDetail";
      params: { hospital: string; card: string; pk: string };
    }
  | {
      message: "GetListMedProgram";
      params: { hospital: string; med_program: string; card: string };
    }
  | {
      message: "HandleGetTopService";
      params: { code?: string; simulator?: boolean; card?: string };
    }
  | {
      message: "HandleSearchListDoctor";
      params: {
        doctorId?: string;
        name?: string;
        emptyClear?: boolean;
        hospitalCode?: string;
      };
    }
  | {
      message: "HandleConsentCheckup";
      params: {
        history: History<any>;
        checkup: Record<string, any>;
        card: string;
      };
    }
  | {
      message: "HandleConfirmCheckupType";
      params: {
        history: History<any>;
        checkup: Record<string, any>;
        card: string;
      };
    };

export type Data = {};

type Handler<P = any, R = any> = (
  controller: WasmController<State & Picked, Event, Data>,
  params: P
) => R;

type Params<A extends Event["message"]> = Extract<
  Event,
  { message: A }
>["params"];

/* ------------------------------------------------------ */

/*                         Handler                        */

/* ------------------------------------------------------ */
export const HandleGetTopService: Handler<
  Params<"HandleGetTopService">
> = async (controller, params) => {
  let state = controller.getState();
  const card = params.card || "";

  if (params.card) {
    controller.setState({
      loadingStatus: { ...state.loadingStatus, [card]: true },
    });
  }

  let temp: any[] = [[null, null], {}];

  if ((params?.simulator && params?.code) || !params?.simulator) {
    temp = await Promise.all([GetTopService(controller, params), {}]);
  }

  const [[resTopService], configPrxEnableEcoupon] = temp;

  const teleConsult = {
    active: true,
    display: "Tele-consult",
    icon: null,
    icon_url: "/images/Appointment/service-tele-consult.png",
    id: "telemed",
    is_telemed: true,
  };

  const ecoupon = {
    active: true,
    display: "E-coupon",
    icon: null,
    icon_url: "/images/Appointment/service-e-coupon.png",
    id: "ecoupon",
    is_ecoupon: true,
  };

  // const topService = [teleConsult, ecoupon, ...(resTopService?.items || [])];
  const topService = [...(resTopService?.items || [])];

  if (!configPrxEnableEcoupon) {
    topService.splice(1, 1);
  }

  state = controller.getState();

  controller.setState({
    topServiceList: topService,
    loadingStatus: { ...state.loadingStatus, [card]: false },
  });
};

export const HandleSearchListDoctor: Handler = async (controller, params) => {
  const state = controller.getState();

  if (params.emptyClear && !params.name && !params.doctorId) {
    return controller.setState({
      loadingSearch: false,
      textSearch: params.name,
      doctorSearchList: null,
    });
  }

  controller.setState({ loadingSearch: true, textSearch: params.name });
  const hospital = getListHospitalForAPI(controller, params);
  const result = await GetAvailableDoctorFilterNOrder(controller, {
    ...params,
    hospitalCode: hospital,
    refresh: true,
  });

  controller.setState({
    loadingSearch: false,
    doctorSearchList: result.result,
  });
};

export const GetListAvailableDoctor: Handler<
  Params<"GetListAvailableDoctor">
> = async (controller, params) => {
  let state = controller.getState();
  const items = state.availableDoctorSearch?.items || [];

  const card = params.card || "";
  let status = params.status ? "LOADING" : true;

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: status },
  });

  const locState = params.history.location.state || {};
  const centerIds = {
    center_group_id: locState?.centergroup?.id || 0,
    center_group_slug: locState?.centergroup?.slug || "",
    center_id: locState?.center?.id || 0,
    center_slug:
      state.language === "th-TH"
        ? locState?.center?.full_title_th || ""
        : locState?.center?.full_title_en || "",
  };

  const hospital = getListHospitalForAPI(controller, params);
  const result = await GetAvailableDoctorFilterNOrder(controller, {
    ...params,
    page: params.page,
    hospitalCode: hospital,
    pagination: true,
    medProgram: true,
    medProgramCenters: centerIds || undefined,
  });

  

  state = controller.getState();
  status = params.status ? "SUCCESS" : false;

  const data = {
    total: result.result?.total,
    items: result.filter,
    page: params.page,
  };

  if (params.concat && data.items) {
    data.items = [...items, ...data.items];
  }

  controller.setState({
    availableDoctorSearch: data,
    loadingStatus: { ...state.loadingStatus, [card]: status },
    allAvailableDoctorList: result.result,
  });
};

export const GetListCenterGroup: Handler<Params<"GetListCenterGroup">> = async (
  controller,
  params
) => {
  let state = controller.getState();
  const hospital = getListHospitalForAPI(controller, params);
  const card = params.card || "";

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: true },
  });

  const [result] = await FastAPIRequestView.get({
    bearer: controller.cookies.get("bearer"),
    endpoint: APIS.CENTER_GROUP_APP,
    params: {
      hospital: hospital,
    },
  });

  let items: any[] = Object.values(result || {});

  items = items.map((item) => ({
    ...item,
    name: params.lang === "th" ? item.name_th : item.name_en,
    image: item.icon_url,
    appointment_type: [5399,796].includes(item.id) || item.name_en.includes("Check-up")
      ? "check_up"
      : "specialty",
  })).sort((a, b) => a.order - b.order);

  controller.setState({
    centerGroupList: items,
    loadingStatus: { ...state.loadingStatus, [card]: false },
  });
};

export const GetListAppointmentCenter: Handler<
  Params<"GetListAppointmentCenter">
> = async (controller, params) => {
  const hospital = getListHospitalForAPI(controller, params);
  const [result] = await FastAPIRequestView.get({
    bearer: controller.cookies.get("bearer"),
    endpoint: APIS.CENTER_APP,
    params: {
      hospital: hospital,
      ...(params.centerGroup && {center_group: params.centerGroup})
    },
  });

  let items: any[] = Object.values(result || {});

  items = items.map((item) => ({
    ...item,
    name: params.lang === "th" ? item.full_title_th : item.full_title_en,
    image: item.image_url,
  })).sort((a, b) => a.order - b.order);

  controller.setState({
    appointmentCenterList: items,
  });
};

export const GetListMedService: Handler<Params<"GetListMedService">> = async (
  controller,
  params
) => {
  let state = controller.getState();
  const card = params.card || "";

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: true },
  });

  const [res] = await V3MedServicesListView.list({
    params: {
      hospital: params.hospital,
    },
    apiToken: controller.cookies.get("apiToken"),
  });

  state = controller.getState();

  const seq = {
    First: 1,
    Follow: 2,
    Other: 3,
  } as any;

  let items = (res?.items || []).map((item: any) => {
    const seqNumber =
      seq[/First|Follow|Other/g.exec(item.name_en)?.[0] || ""] || 99;

    return {
      ...item,
      seq: seqNumber,
      ...(seqNumber === 1 && { first_consultation: true }),
    };
  });

  items = items.sort((a: any, b: any) => a.seq - b.seq);

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: false },
    medServiceLists: items,
  });
};

export const GetMedServiceDetail: Handler<
  Params<"GetMedServiceDetail">
> = async (controller, params) => {
  let state = controller.getState();
  const card = params.card || "";

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: true },
  });


  const [res] = await V3MedServicesDetailView.retrieve({
    params: {
      hospital: params.hospital,
    },
    pk: params.pk,
    apiToken: controller.cookies.get("apiToken"),
  });

  state = controller.getState();

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: false },
    medServiceDetail: res,
  });
};

export const GetListMedProgram: Handler<Params<"GetListMedProgram">> = async (
  controller,
  params
) => {
  let state = controller.getState();
  const card = params.card || "";

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: true },
  });

  const searchProgram = V3SearchProgramSpecialtyListView.list({
    apiToken: controller.cookies.get("apiToken"),
    params: {
      hospital: params.hospital,
      med_program: params.med_program,
    },
  });

  const medProgramsList = V3MedProgramsListView.list({
    apiToken: controller.cookies.get("apiToken"),
    params: {
      // ...(params.hospitalCode && { hospital: params.hospitalCode }),
    },
  })

  const apiList = [searchProgram , medProgramsList];

  const [searchProgramRes, medProgramsListRes] = await Promise.all(apiList);

  const items = (searchProgramRes?.[0]?.items || []).filter(
    (item: any) => {
      const medProgramItem = (medProgramsListRes[0]?.items || []).find((medItem:any) => medItem?.id === item?.id)
      return item?.type === "med_program" && medProgramItem?.center_ids?.length === 0
    }
  );

  state = controller.getState();

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: false },
    medProgramLists: items,
  });
};

export const HandleDoctorAppointmentAction: Handler<
  Params<"HandleDoctorAppointmentAction">
> = async (controller, params) => {
  const state = controller.getState();
  const locState = params.history.location.state || {};
  const card = params.card || "";

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: true },
  });

  let families = await GetFamilies(controller, { refresh: params.action });

  const doctor = params.doctor;
  const singleLocation = doctor.divisions?.length === 1;
  const isFamily = !!families?.length;
  const action = params.action || locState.appointmentLocation;

  const url = DetermineRedirectUrl({
    doctor,
    singleLocation,
    isFamily,
    action,
  });

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: false },
  });

  if (url) {
    const division = doctor.divisions?.[0] || {};

    const formattedDivision = {
      id: division.division_id,
      name: division.division_name,
      price: division.doctor_fee,
      is_telemed: !!division.is_telemed,
    };

    const state = {
      doctor,
      appointmentLocation: action,
      division: params.division ? params.division : formattedDivision,
      appointmentType: "doctor",
      families,
      hospital: {
        code: doctor.hospital_code,
        name: doctor.hospital_name,
      },
    } as any;

    if (singleLocation && !isFamily) {
      state.appointmentFor = "myself";
    }

    controller.handleEvent({
      message: "HandleHistoryPushState" as any,
      params: {
        pathname: url,
        history: params.history,
        state,
        storedState: params.storedState,
      } as any,
    });
  }
};

const DetermineRedirectUrl = (params: {
  doctor: any;
  isFamily: boolean;
  singleLocation: boolean;
  action: any;
}) => {
  let url = "";

  const doctor = params.doctor;
  const pathname = globalThis.location.pathname;
  const filterDivision = (doctor.divisions || []).filter((item: any) => {
    if (params.action === "online") {
      return item.is_telemed;
    } else {
      return true;
    }
  });

  const multiLocations = (filterDivision?.length || 0) > 1;

  // กรณีที่แพทย์ออกตรวจมากกว่า 1 location
  if (multiLocations) {
    url = URLS.SELECT_CLINIC;

    if (pathname.includes(URLS.SELECT_CLINIC)) {
      url = params.isFamily ? URLS.APPOINTMENT_FOR : URLS.APPOINTMENT_REASON;
    }
  }
  // กรณีที่แพทย์ออกตรวจแค่ 1 location (ผูก family)
  else if (params.singleLocation && params.isFamily) {
    url = URLS.APPOINTMENT_FOR;
  }
  // กรณีที่แพทย์ออกตรวจแค่ 1 location (ไม่ได้ผูก family)
  else if (params.singleLocation) {
    url = URLS.APPOINTMENT_REASON;
  } else {
    url = URLS.APPOINTMENT_REASON;
  }

  return url;
};

export const HandleConfirmCheckupType: Handler<
  Params<"HandleConfirmCheckupType">
> = async (controller, params) => {
  const state = controller.getState();
  const card = params.card || "";

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: true },
  });

  const [res] = await V3MedProgramsDetailView.retrieve({
    apiToken: controller.cookies.get("apiToken"),
    pk: params.checkup.id,
  });

  if (res.diag_rule) {
    const [resCheck,errorCheck] = await CheckRequireDiagRuleView.get({
      apiToken: controller.cookies.get("apiToken"),
      params: { division: res.division || "", diag_rule:res.diag_rule, code: "TM" },
    });
  
    if (!errorCheck && !resCheck?.finished) {
      const state = params.history.location.state
      const checkUp = { ...params.checkup, ...res }
      params.history.push({
        pathname: `/form/${resCheck.publish_diag_rule}`,
        state: {...state,checkup:checkUp, storedState : {checkup: checkUp } },
        search: `?app=MobAppointment&med_program=${params.checkup.id}&smart_appointment=true`,
      });
      globalThis.history.go();

      return;
    }
  }

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [card]: false },
  });

  controller.handleEvent({
    message: "HandleHistoryPushState",
    params: {
      history: params.history,
      pathname: URLS.SELECT_DATETIME,
      state: {
        checkup: { ...params.checkup, ...res },
      },
    },
  } as any);
};

const GetFamilies: Handler = async (controller, params) => {
  let families = globalThis.history.state?.state?.families || [];

  if (params.refresh) {
    const [result] = await GetUserFamily(controller, {});

    families = result.results || [];
  }

  return families;
};

/* ------------------------------------------------------ */

/*                          APIS                          */

/* ------------------------------------------------------ */

const GetUserFamily: Handler = async (controller, params) => {
  return await UserFamilyAPI.list({
    params: params,
    apiToken: controller.cookies.get("apiToken"),
  });
};

const GetTopService: Handler<{ code?: string }> = async (
  controller,
  params
) => {
  let state = controller.getState();
  let lang = "";

  if (globalThis.mobile.iOSLang) {
    lang = globalThis.window.navigator?.language;
  }

  const [res, error, network] = await V3TopServicesListView.list({
    apiToken: controller.cookies.get("apiToken"),
    ...(lang && { extra: { headers: { "Accept-Language": lang } } }),
    params: {
      hospital: params.code ? params.code : state.selectedHospital?.code,
    },
  });

  return [res, error, network];
};

// -const GetAvailableDoctor: Handler<
//   {
//     limit?: number;
//   } & FilterDoctorType
// > = async (controller, params) => {
//   let lang = "";
//   if (globalThis.window.mobile.iOSLang) {
//     lang = globalThis.window.navigator?.language;
//   }
//   const [res, error, network] = await V3AvailableDoctorListView.list({
//     apiToken: controller.cookies.get("apiToken"),
//     params: {
//       limit: params.limit ? params.limit : LIMIT_SEARCH,
//       offset: LIMIT_SEARCH * ((params.page || 1) - 1),
//       gender: params.gender,
//       name: params.name,
//       centergroup: params.centergroup,
//       center: params.center,
//       hospital: params.hospital,
//       telemed: params.telemed,
//       onsite: params.onsite,
//       score: params.score,
//     },
//     ...(lang && { extra: { headers: { "Accept-Language": lang } } }),
//   });
//   return [res, error, network];
// };

const GetAvailableDoctorFilterNOrder: Handler<
  {
    refresh?: boolean;
    limit?: number;
    pagination?: boolean;
    hospitalCode?: string;
    medProgram?: boolean;
    doctorId?: String;
  } & Types.FilterDoctorType,
  Promise<{ result: any; filter: any[] }>
> = async (controller, params) => {
  console.log("Debug ~ GetAvailableDoctorFilterNOrder params:", params);
  const state = controller.getState();

  let result: { items: any[]; total: number } | undefined;

  if (params.refresh) {
    const apiDoctorApp = FastAPIRequestView.get({
      bearer: controller.cookies.get("bearer"),
      endpoint: APIS.DOCTOR_APP,
      params: {
        ...(params.name && { search: params.name || undefined }),
        ...(params.doctorId && { doctor_id: params.doctorId || undefined }),
        center: params.defaultCenter,
        ...(params.hospitalCode && { hospital: params.hospitalCode }),
      },
    });

    const apiList = [apiDoctorApp];

    if (params.medProgram && !params.name) {
      apiList.push(
        V3MedProgramsListView.list({
          apiToken: controller.cookies.get("apiToken"),
          params: {
            // ...(params.hospitalCode && { hospital: params.hospitalCode }),
            center_id: params.medProgramCenters?.center_id, //params.defaultCenter,
          },
        })
      );
    }

    const [doctorApp, medProgramRes] = await Promise.all(apiList);

    let medProgramList: any[] = [];
    let doctorList: any[] = [];

    if (doctorApp?.[0]) {
      doctorList = (doctorApp[0] || []).map((item: any) => ({
        ...item,
        centerids: item.centers.map((acc: any) => acc.center_id),
        doctor_fee: Math.min(HandleCheckMinDoctorFee(item.divisions)),
      }));

      doctorList = doctorList.filter((item: any) => item.centers?.length);
      doctorList = doctorList.filter((item: any) => params.hospitalCode?.includes(item.hospital_code));
    }

    if (medProgramRes?.[0]) {
      medProgramList = medProgramRes[0]?.items || [];
      // Prepare data medProgram
      medProgramList = medProgramList.map((item: any) => ({
        ...item,
        full_name: item.name,
        isMedProgram: true,
        centerids: params.medProgramCenters,
        is_telemed: false,
        is_onsite: true,
        doctor: {
          full_name: item.name,
          code: item.doctor_code,
          ...(item.image && {image: item.image})
        },
        division: {
          division_id: item.division,
          name: params.medProgramCenters?.center_slug,
          division_code: item.location_code,
        },
        reason: {
          id: item.service,
        },
      }));
    }

    result = {
      items: [...doctorList, ...medProgramList],
      total: (doctorList.length || 0) + (medProgramList.length || 0),
    };
  } else {
    result = state.allAvailableDoctorList;
  }

  const limit = params.limit ? params.limit : LIMIT_SEARCH;
  const page = params.page || 1;
  const offset = (page - 1) * limit;

  let filter = (result?.items || []).filter((item: any) => {
    return (
      // compareValue(item.full_name, params.name, "in") &&
      compareValue(item.score, params.score) &&
      compareValue(item.is_telemed, params.telemed) &&
      compareValue(item.is_onsite, params.onsite) &&
      compareValue(item.experience, params.experience, "er") &&
      compareValue(item.gender, params.gender) &&
      compareValue(item.hospital_code, params.hospitals, "in") &&
      compareValue(item.centerids, params.center, "in")
    );
  });

  if (params.order) {
    filter = sortDataByField(filter, params.order);
  }

  return {
    result,
    filter: filter.slice(offset, offset + limit),
  };
};

/* ------------------------------------------------------ */

/*                          Utils                         */

/* ------------------------------------------------------ */
const compareValue = (
  data: number | string | boolean | number[],
  compare?: number | string | boolean | string[] | number[],
  operator: "eq" | "in" | "er" | "gte" = "eq"
) => {
  const isCompare = Array.isArray(compare) ? compare.length : compare;

  if (!isCompare) {
    return true;
  }

  const operators = {
    eq: () => data === compare,
    gte: () => compare && data >= compare,
    in: () => {
      if (typeof data === "string") {
        if (Array.isArray(compare)) {
          return compare.includes(data);
        } else if (typeof compare === "string") {
          return data.includes(compare);
        }
      } else if (Array.isArray(data) && typeof compare === "number") {
        return data.includes(compare);
      } else if (Array.isArray(data) && typeof compare === "string") {
        return data.includes(compare);
      }
      return false;
    },
    er: () => {
      if (
        Array.isArray(compare) &&
        typeof data === "number" &&
        typeof compare[0] === "number" &&
        typeof compare[1] === "number"
      ) {
        const start = compare[0];
        const end = compare[1];
        return start <= data && data <= end;
      }
      return false;
    },
    // Add more operators as needed
  };

  return operators[operator]();
};

const sortDataByField = (data: any[], order: Types.OrderByType) => {
  const sortFunctions = {
    asc: (a: any, b: any) => parseFloat(a) - parseFloat(b),
    desc: (a: any, b: any) => parseFloat(b) - parseFloat(a),
  };

  const sortedData = data.sort((a, b) => {
    let valueA = checkDFValue(a, order);
    let valueB = checkDFValue(b, order);

    if (valueA === null || valueA === undefined) return 1;

    if (valueB === null || valueB === undefined) return -1;

    return sortFunctions[order.by](valueA, valueB);
  });

  return sortedData;
};

const checkDFValue = (value: any, order: Types.OrderByType) => {
  if (order.field !== "doctor_fee") {
    return value[order.field];
  }
  return value["is_telemed"] ? value[order.field] : 0;
};

const getListHospitalForAPI: Handler = (controller, params) => {
  const state = controller.getState();
  const hospital = params.hospital || params.hospitalCode;
  if (hospital === "-1") {
    const hospitalHaveHN = state.hospitalList?.map((item) => {
      if (item.hn) {
        return item.code;
      }
      return undefined
    });

    const hospital = (hospitalHaveHN || []).concat(
      CONFIG.ENABLE_HOSPITAL_APPOINTMENT
    );
    const uniqueHospitalList: string[] = [];

    hospital.forEach((item) => {
      if (!uniqueHospitalList.includes(item || "") && item) {
        uniqueHospitalList.push(item || "");
      }
    });

    return uniqueHospitalList;
  } else {
    return [hospital];
  }
};

const HandleCheckMinDoctorFee = (divisions: any) => {
  const minDF = divisions
    .map((division: any) => Number(division.doctor_fee))
    .filter((item: any) => item != 0);
  if (minDF.length > 0) {
    return minDF;
  } else {
    return [];
  }
};
